import React from "react";
import WebTheme from "../web-theme/WebTheme";
import Users from "../users/Users";
import UserProfile from "../users/UserProfile";
import GenerationMonitor from "../generationMonitor/GenerationMonitor";
import { TranslateContext } from "../../context/TranslateContext";
import ManagePlans from "../manage-plans/ManagePlans";
import Templates from "../templates/Templates";
import SupportAdmin from "../support/SupportAdmin";
import TaskPricing from "../taskPrice/TaskPricing";
import PromptTemplate from "../prompttemp/PromptTemplate";
import PromptLibraryAdmin from "../promptLibrary/PromptLibraryAdmin";
import BeyundAiProviders from "../beyundAiProvider/BeyundAiProviders";
import ModelRegistry from "../modelRegistry/ModelRegistry";
import EmailSettings from "../emailSettings/EmailSettings";
import EmailTemplates from "../emailTemplates/EmailTemplates";
import MarketingCampaigns from "../marketing/MarketingCampaigns";
import MarketingOverview from "../marketing/MarketingOverview";
import MarketingAutomations from "../marketing/MarketingAutomations";
import MarketingAudiences from "../marketing/MarketingAudiences";
import MarketingPromos from "../marketing/MarketingPromos";
import PaymentGateway from "../paymentGateway/PaymentGateway";
import Blogs from "../blogs/Blogs";
import SiteSettings from "../siteSettings/SiteSettings";
import AdsTracking from "../siteSettings/AdsTracking";
import Leads from "../leads/Leads";
import WebTranslation from "../webTranslation/WebTranslation";
import Dash from "./Dash";
import Orders from "../orders/Orders";
import PoyoProfit from "../poyoProfit/PoyoProfit";
import SocialLogin from "../socialLogin/SocialLogin";
import UpdateApp from "../updateaApp/UpdateApp";
import AffiliateAdmin from "../affiliate/AffiliateAdmin";
import LeadCloserConversations from "../leadCloser/LeadCloserConversations";

const Content = ({ selectedMenu, web, onNavigate }) => {
  const { lang } = React.useContext(TranslateContext);

  return (
    <div>
      {selectedMenu === "dashboards" && <Dash lang={lang} />}
      {selectedMenu === "generation-monitor" && <GenerationMonitor lang={lang} />}
      {selectedMenu === "users" && <Users lang={lang} />}
      {selectedMenu === "user-profile" && <UserProfile lang={lang} />}
      {selectedMenu === "plans" && <ManagePlans lang={lang} />}
      {selectedMenu === "templates" && <Templates lang={lang} />}
      {selectedMenu === "web-theme" && <WebTheme lang={lang} />}
      {selectedMenu === "task-pricing" && <TaskPricing lang={lang} />}
      {selectedMenu === "prompt-template" && <PromptTemplate lang={lang} />}
      {selectedMenu === "prompt-library" && <PromptLibraryAdmin lang={lang} />}
      {selectedMenu === "beyund-ai-provider" && <BeyundAiProviders lang={lang} />}
      {selectedMenu === "model-registry" && <ModelRegistry lang={lang} />}
      {selectedMenu === "payment-gateway" && <PaymentGateway lang={lang} />}
      {selectedMenu === "email-settings" && <EmailSettings lang={lang} />}
      {selectedMenu === "email-templates" && <EmailTemplates lang={lang} />}
      {selectedMenu === "marketing-overview" && (
        <MarketingOverview lang={lang} onNavigate={onNavigate} />
      )}
      {selectedMenu === "email-campaigns" && <MarketingCampaigns lang={lang} />}
      {selectedMenu === "marketing-automations" && (
        <MarketingAutomations lang={lang} />
      )}
      {selectedMenu === "marketing-audiences" && (
        <MarketingAudiences lang={lang} />
      )}
      {selectedMenu === "marketing-promos" && <MarketingPromos lang={lang} />}
      {selectedMenu === "blogs" && <Blogs lang={lang} />}
      {selectedMenu === "leads" && <Leads lang={lang} />}
      {selectedMenu === "lead-closer" && <LeadCloserConversations />}
      {selectedMenu === "orders" && <Orders lang={lang} />}
      {selectedMenu === "affiliate" && <AffiliateAdmin lang={lang} />}
      {selectedMenu === "poyo-profit" && <PoyoProfit lang={lang} />}
      {selectedMenu === "site-settings" && (
        <SiteSettings lang={lang} web={web} />
      )}
      {selectedMenu === "ads-tracking" && <AdsTracking />}
      {selectedMenu === "help" && <SupportAdmin lang={lang} />}
      {selectedMenu === "web-translation" && <WebTranslation lang={lang} />}
      {selectedMenu === "social-login" && <SocialLogin lang={lang} />}
      {selectedMenu === "update" && <UpdateApp lang={lang} />}
    </div>
  );
};

export default Content;
